import { getAdditionalUserInfo, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, database } from "../../../Utils/firebase";
import { CreateNewAccountMailAPI } from "../../../MailAPIs/CreateNewAccountMailAPI";
import { ref, get, set } from "firebase/database";
import GetUserDataFirebase from "../User/GetUserDataFirebase";
import { AddUser } from "../../index";
import AddUserDataInFirebase from "../User/AddUserDataInFirebase";
import { UpdateNodeIdInFirebase } from "../UpdateNodeIdInFirebase";
import { generateReferralCode } from "../../../Utils/ReferralCodeGenerator";
import GetRefereeUserDataInFirebase from "../User/GetReferreUserDataInFirebase";
import SyncReferralMapping from "../User/SyncReferralMapping";


export const LoginWithGoogle = async (dispatch, state, referral_code) => {
    try {
        const googleProvider = new GoogleAuthProvider();
        googleProvider.addScope("email");

        const result = await signInWithPopup(auth, googleProvider);

        // ✅ Use getAdditionalUserInfo() to check if the user is new
        const additionalInfo = getAdditionalUserInfo(result);
        console.log("additionalInfo", additionalInfo);
        const isNewUser = additionalInfo?.isNewUser;

        // ✅ Get user details
        const user = result?.user;
        const authId = user?.uid;
        const socialId = user?.providerData[0]?.uid;
        const now = user?.metadata?.creationTime;
        const creationDate = new Date(now);

        // Convert to Unix timestamp (milliseconds since 1970)
        const timestampMillis = creationDate.getTime();

        // Or convert to seconds (optional)
        const timestampSeconds = Math.floor(timestampMillis / 1000);

        if (isNewUser) {
            CreateNewAccountMailAPI(user?.email, user?.displayName);
        }

        const firebaseRef = ref(database, `invoiceGenerator/users/${authId}`);
        const firebaseSnapshot = await get(firebaseRef);
        const firebaseData = firebaseSnapshot?.val();

        const data = {
            name: user?.displayName,
            email: user?.email || result?._tokenResponse?.email,
            userPhoto: user?.photoURL,
            social_id: user?.providerData[0]?.uid,
            contact: user?.contact || "",
            user_uid: user?.uid || "",
            currency: user?.currency || "IND",
            razorpayId: null,
            platform: "Website",
            razorpayId: "",
            SharedCompanies: user?.SharedCompanies || "",
        };

        // 🔥 NEW REFERRAL LOGIC — works for new users only
        if (isNewUser) {

            const referralForThisUser = generateReferralCode();

            // Sync referral mapping globally
            const finalReferralCode = await SyncReferralMapping(authId, data, dispatch);

            // save user node with referral code
            await set(ref(database, `invoiceGenerator/users/${authId}/user`), {
                ...data,
                referral_code: finalReferralCode,
                referredBy: referral_code,

            });

            // if user came via someone’s referral
            if (referral_code) {
                await set(ref(database, `invoiceGenerator/referredUsers/${referral_code}/${authId}`), {
                    name: data?.name,
                    email: data?.email,
                    platform: data?.platform,
                    referredBy: referral_code,
                    createdAt: timestampSeconds,
                    acceptedAt: "",
                    status: data?.status || "pending"
                });
            }
        }

        // ✅ Your OLD LOGIC (untouched, just runs as it was)
        if (firebaseData != null) {
            const userdata = await GetUserDataFirebase(authId);

            if (userdata !== null) {
                // Ensure referral mapping is synced
                const finalCode = await SyncReferralMapping(authId, userdata || data, dispatch);

                data.name = userdata?.name;
                data.email = userdata?.email;
                data.contact = userdata?.contact;
                data.currency = userdata?.currency;
                data.razorpayId = userdata?.razorpayId;
                data.platform = userdata?.platform || "Website";
                data.referral_code = finalCode || userdata?.referral_code || data?.referral_code || "";
                data.referredBy = userdata?.referredBy || data?.referredBy || "";
                data.SharedCompanies = userdata?.SharedCompanies || data?.SharedCompanies || "";

            } else {
                setTimeout(() => {
                    if (isNewUser) {
                        AddUserDataInFirebase(state, dispatch, authId, data);
                    } else {
                        AddUserDataInFirebase(state, dispatch, socialId, data);
                    }
                }, [1000]);
            }
        } else {
            // await UpdateNodeIdInFirebase(dispatch, authId, socialId);

            const userdata = await GetUserDataFirebase(authId);

            // Ensure referral mapping is synced
            const finalCode = await SyncReferralMapping(authId, userdata || data, dispatch);

            if (userdata !== null) {
                data.name = userdata?.name;
                data.email = userdata?.email;
                data.contact = userdata?.contact;
                data.currency = userdata?.currency;
                data.razorpayId = userdata?.razorpayId;
                data.platform = userdata?.platform || "Website";
                data.referral_code = finalCode || userdata?.referral_code || data?.referral_code || "";
                data.referredBy = userdata?.referredBy || data?.referredBy || "";
                data.SharedCompanies = userdata?.SharedCompanies || data?.SharedCompanies || "";
            } else {
                setTimeout(() => {
                    AddUserDataInFirebase(state, dispatch, authId, data);
                }, [1000]);
            }
        }

        return { sucess: true, message: "Login Successfully", data: data, isNewUser };
    } catch (error) {
        console.log("Google Login Error:", error?.message);
        return { sucess: false, message: error?.message, data: null };
    }
};